export default "__VITE_ASSET__D$rt2KJr__"